import React, { FunctionComponent, useEffect, useState } from 'react';
import { Select, Space, Typography } from 'antd';
import {
  PrivacyStatus,
  YoutubeCategories,
  YoutubeCategoryLabels,
  YouTubeMetadata,
} from '@monorepo/types';
import { useTranslation } from 'react-i18next';

const { Text, Title } = Typography;

interface Props {
  metadata: YouTubeMetadata;
  onUpdate: (metadata: Partial<YouTubeMetadata>) => void;
}

const YoutubeForm: FunctionComponent<Props> = ({ metadata, onUpdate }) => {
  const { t } = useTranslation();
  const [localMetadata, setLocalMetadata] = useState<YouTubeMetadata>(metadata);

  const handlePrivacyChange = (value: PrivacyStatus) => {
    setLocalMetadata({ ...localMetadata, privacyStatus: value });
    onUpdate({ ...metadata, privacyStatus: value });
  };

  const handleCategoryUpdate = (value: YoutubeCategories) => {
    setLocalMetadata({ ...localMetadata, category: value });
    onUpdate({ ...metadata, category: value });
  };

  useEffect(() => {
    setLocalMetadata(metadata);
  }, [metadata]);

  const privacyLabels: Record<PrivacyStatus, string> = {
    [PrivacyStatus.Public]: t(
      'videoEditor.socialPublish.youtube.privacyPublic'
    ),
    [PrivacyStatus.Private]: t(
      'videoEditor.socialPublish.youtube.privacyPrivate'
    ),
    [PrivacyStatus.Unlisted]: t(
      'videoEditor.socialPublish.youtube.privacyUnlisted'
    ),
  };

  return (
    <div>
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        <div>
          <Title level={5} style={{ margin: '0px' }}>
            {t('videoEditor.socialPublish.youtube.privacyStatus')}
          </Title>
          <Select
            placeholder={t('videoEditor.socialPublish.common.selectPrivacy')}
            style={{ width: '100%' }}
            value={localMetadata.privacyStatus}
            onChange={handlePrivacyChange}
          >
            {Object.values(PrivacyStatus).map((privacyStatus) => (
              <Select.Option key={privacyStatus} value={privacyStatus}>
                {privacyLabels[privacyStatus]}
              </Select.Option>
            ))}
          </Select>
          <Title level={5} style={{ margin: '0px' }}>
            {t('videoEditor.socialPublish.youtube.category')}{' '}
            <Typography.Text type={'secondary'}>
              {t('videoEditor.socialPublish.youtube.categoryHint')}
            </Typography.Text>
          </Title>
          <Select
            placeholder={t(
              'videoEditor.socialPublish.youtube.categoryPlaceholder'
            )}
            style={{ width: '100%' }}
            value={localMetadata.category}
            onChange={handleCategoryUpdate}
          >
            {Object.values(YoutubeCategories).map((category) => (
              <Select.Option key={category} value={category}>
                {YoutubeCategoryLabels[category]}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Space>
    </div>
  );
};

export default YoutubeForm;
